<template>
  <select :value="selectedLanguageLocal.language" @change="onChangeSelect($event)" :style="{...myBlockProps.getStyles(visible), ...textStyles}">
    <option v-for="info in languageInfoList" :key="info.language" :value="info.language" :style="textStyles">
      {{ info.countryCode.toUpperCase() }}
    </option>
  </select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Block from './Block.vue';

import { LanguageInfo, TextProps } from '../models';

export default {
  name: 'language-select-block',
  extends: Block,
  data() {
    return {
      modalOpen: false
    };
  },
  props: {
    textProps: { type: Object, default: () => ({}) },
    languages: { type: Array, default: () => ([]) }
  },
  computed: {
    ...mapGetters(['selectedLanguage']),
    textStyles() {
      const textProperties = new TextProps(this.textProps);
      return textProperties.getStyles();
    },
    languageInfoList() {
      return this.languages.map((languageInfo) => new LanguageInfo(languageInfo));
    },
    selectedLanguageLocal() {
      return this.languageInfoList.find((languageInfo) => languageInfo.language === this.selectedLanguage);
    },
  },
  methods: {
    ...mapActions(['setSelectedLanguage']),
    onSelectLanguage(language) {
      this.setSelectedLanguage(language);
    },
    onChangeSelect(event) {
      this.onSelectLanguage(event.target.value);
    }
  },
};
</script>

<style scoped lang="scss">
select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 2px 5px;
  font-size: 14px;
}
</style>
